const CLEAR_SUBMISSION = (state) => {
  state.submissionItem = undefined;
  state.submissionIErrors = [];
};

export default CLEAR_SUBMISSION;
